import {
  Content,
  ReviewerInfo,
  TestimonialCarousel,
} from "@faire/deprecated-retailer-visitor-shared/components/TestimonialCarousel/TestimonialCarousel";
import { useGetFaireAcademyPageState } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import { FALLBACK_NAM_TESTIMONIALS } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/consts";
import { OWF_SECTION_NAME } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/types";
import { Core } from "@faire/design-tokens";
import { QueryParameters as NAMTestimonialParameters } from "@faire/web-api--source/endpoints/www/api/testimonial/get";
import { useQuery as useTestimonialsQuery } from "@faire/web-api--source/endpoints/www/api/testimonial/get-hooks";
import { trackOpenWithFaireFaireAcademySectionView } from "@faire/web-api--source/events/openWithFaire/view/faireAcademySection";
import { ITestimonial } from "@faire/web-api--source/indigofair/data/ITestimonial";
import { useStrictLocalization } from "@faire/web/common/localization";
import { trackEvent } from "@faire/web/common/trackEvent";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { TypographyStyles } from "@faire/web/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { SlideIn } from "@faire/web/ui/SlideIn/SlideIn";
import * as React from "react";
import styled from "styled-components";

export const OpenWithFaireTestimonial: React.FC<{ viewEvent?: string }> = ({
  viewEvent,
}) => {
  const { strictLocalize } = useStrictLocalization();
  const { data } = useTestimonialsQuery(
    NAMTestimonialParameters.build({
      type: ITestimonial.Type.OPEN_WITH_FAIRE_NORTH_AMERICA,
    })
  );
  const { pageState } = useGetFaireAcademyPageState();
  const ref = useDoActionWhenVisible(() => {
    if (viewEvent) {
      trackEvent(viewEvent);
    }
    trackOpenWithFaireFaireAcademySectionView(
      pageState,
      OWF_SECTION_NAME.TESTIMONIAL
    );
  });

  const testimonials = data?.testimonials?.length
    ? data.testimonials
    : FALLBACK_NAM_TESTIMONIALS(strictLocalize);

  const filteredTestimonials = testimonials
    .filter(
      (testimony) =>
        testimony.image?.url &&
        testimony.testimony &&
        testimony.author &&
        testimony.retailer_name
    )
    .map((testimony) => ({
      avatarImageUrl: testimony.image!.url!,
      content: testimony.testimony!,
      reviewerInfo: `${testimony.author}, ${testimony.retailer_name}`,
    }));

  return (
    <div ref={ref}>
      <SlideIn offset="60px">
        <StyledTestimonialCarousel
          name="lwf-testimonials"
          eventPrefix="/lwf/testimonial/"
          items={filteredTestimonials}
          maxContentWidth={750}
        />
      </SlideIn>
    </div>
  );
};

const StyledTestimonialCarousel = styled(TestimonialCarousel)`
  background-color: ${Core.surface.inverse};
  height: 476px;

  ${responsiveMediaQueries.desktopAndAbove} {
    ${Content} {
      ${TypographyStyles({
        variant: "displayMSerifRegular",
      })};
    }
    ${ReviewerInfo} {
      ${TypographyStyles({
        variant: "subheadingSansRegular",
      })};
    }
  }

  ${responsiveMediaQueries.mobile} {
    height: auto;
    padding: ${getSpacing("8x", 0)};
  }
`;
